'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasMoreMessages = undefined;

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _getters = require('./getters');

var _hasMessages = require('./hasMessages');

/**
 * True if a ThreadHistory has more messages on the server
 * 
 * @param {ThreadHistory} threadHistory 
 * @returns {Boolean}
 */
var hasMoreMessages = exports.hasMoreMessages = function hasMoreMessages(threadHistory) {
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  var latestIsStart = (0, _getters.getStartTimestamp)(threadHistory) === (0, _getters.getEndTimestamp)(threadHistory);

  return (0, _hasMessages.hasMessages)(threadHistory) && !latestIsStart;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasMoreMessages.js
// module id = 1082
// module chunks = 2 3